import React from 'react';
import CallDashboardKeyNotesForm from 'components/molecules/call-dashboard/forms/key-notes';

interface IProps {
  patientGuid: string;
}

const CallDashboardKeyNotesTab: React.FC<IProps> = (props) => {
  const { patientGuid } = props;

  return (
    <div>
      <CallDashboardKeyNotesForm patientGuid={patientGuid} />
    </div>
  );
};

export default CallDashboardKeyNotesTab;
